require( 'intersection-observer' );
import Siema from '../../../js/vendor/siema';
import { Helper } from '../../../js/util/helper';

import CountUp from '../../../../node_modules/countup.js/dist/countUp';

export default class Counter {
  constructor( node ) {
    this.node = node;
    this.isSwipeable = node.classList.contains( 'counter--swipeable' );
    this.slider = null;
    this.tabletPortraitSize = 1023;
    this.handleSwipe();
    this.createIntersectionObserver();
  }
  handleSwipe() {
    if ( this.isSwipeable ) {
      this.slider = this.initSlider();
      this.isSlider = true;
      this.addPagination();
      this.watchWindowSize();
      this.setActivePagination( 0 );
    }
  }
  initSlider() {
    return new Siema({
      selector: this.node,
      loop: true,
      onChange: this.setActivePagination.bind( this )
    });
  }
  addPagination() {
    let wrapper = Helper.getClosest( this.node, '.counter--wrapper' );
    let paginationBtns = wrapper.querySelectorAll( '.counter__pagination-box' );
    for ( let paginationBtn of paginationBtns ) {
      paginationBtn.addEventListener( 'click', () => {
        const index = paginationBtn.getAttribute( 'data-index' );
        this.slider.goTo( index );
        this.setActivePagination( index );
      });
    }
  }
  setActivePagination( index = -1 ) {
    let wrapper = Helper.getClosest( this.node, '.counter--wrapper' ),
      paginationBtns = wrapper.querySelectorAll( '.counter__pagination-box' ),
      active = wrapper.querySelector( '.counter__pagination-box--active' );
    const current = ( index === -1 ) ? this.slider.currentSlide : index;
    if ( active !== null ) {
      active.classList.remove( 'counter__pagination-box--active' );
    }
    paginationBtns[ current ].classList.add( 'counter__pagination-box--active' );
  }
  watchWindowSize() {
    if ( window.innerWidth >= this.tabletPortraitSize && this.slider !== -1 ) {
      this.slider.destroy( true );
      this.isSlider = false;
    }
    window.addEventListener( 'resize', () => {
      if ( window.innerWidth < this.tabletPortraitSize && this.isSwipeable && !this.isSlider ) {
        this.slider = this.initSlider();
        this.isSlider = true;
      } else if ( window.innerWidth >= this.tabletPortraitSize && this.isSwipeable && this.isSlider ) {
        this.slider.destroy( true );
        this.isSlider = false;
      }
    });
  }
  handleCounter( value ) {
    let decimal = 0;
    let string = value.innerHTML;
    let number = parseFloat( string.replace( ',', '.' ));
    let lang = document.documentElement.lang;

    let options = {
      useEasing: true,
      useGrouping: true,
      separator: '',
      decimal: ','
    };

    if ( value.classList.contains( 'counter__value--with-dot' )) {
      options.separator = '.';
    }

    if ( lang === 'en' ) {
      if ( value.classList.contains( 'counter__value--with-dot' )) {
        options.separator = ',';
      } else {
        options.separator = '';
      }
      options.decimal = '.';
    }

    if ( string.includes( ',' )) {
      decimal = string.split( ',' )[ 1 ].length;
    }

    let numAnimation = new CountUp( value, 0, number, decimal, 3, options );
    if ( !numAnimation.error ) {
      numAnimation.start();
    } else {
      console.error( numAnimation.error );
    }
  }
  handleIntersectionObserver( entries, observer ) {
    entries.forEach( entry => {
      if ( entry.isIntersecting ) {
        this.handleCounter( entry.target );
        observer.unobserve( entry.target );
      }
    });
  }
  createIntersectionObserver() {
    let observer;
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.25
    };

    let counterValues = this.node.querySelectorAll( '.counter__value' );
    for ( let value of counterValues ) {
      observer = new IntersectionObserver( this.handleIntersectionObserver.bind( this ), options );
      observer.observe( value );
    }
  }
}
